import { RadioGroup } from '@/components/RadioGroup';
import { RevealSlot } from '@/components/RevealSlot';
import {
    selectNoForseeableChangesToCircumstances,
    setForseeableChangesExplanation,
    setNoForseeableChangesToCircumstances,
} from '@/context/borrower';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';

import { ForseeableChangesExplanation } from '../ForseeableChangesExplanation';

export interface IProps {
    baseId: string;
    showErrors: boolean;
}

export const testId = 'ForseeableChangesToCircumstances';

export function ForseeableChangesToCircumstances({
    baseId,
    showErrors,
}: IProps): JSX.Element {
    // ***** Redux *****
    const currentState = useAppSelector(
        selectNoForseeableChangesToCircumstances
    );
    const dispatch = useAppDispatch();

    // ***** Event Handlers *****
    function handleChange(value: string | boolean | undefined): void {
        if (value === undefined) {
            dispatch(setForseeableChangesExplanation(undefined));
            dispatch(setNoForseeableChangesToCircumstances(undefined));
            return;
        }

        dispatch(
            setNoForseeableChangesToCircumstances(
                value === 'YES' ? true : false
            )
        );
    }

    // ***** Render *****
    const options = [
        {
            label: 'Yes',
            value: 'YES',
            id: `${baseId}-button-noForseeableChangesToCircumstances-yes`,
        },
        {
            label: 'No',
            value: 'NO',
            id: `${baseId}-button-noForseeableChangesToCircumstances-no`,
        },
    ];
    return (
        <div data-testid={testId}>
            <RadioGroup
                title='Any foreseeable changes to your circumstances?'
                showErrors={showErrors && currentState === undefined}
                onChange={handleChange}
                options={options}
                value={
                    currentState === undefined
                        ? undefined
                        : currentState
                        ? 'YES'
                        : 'NO'
                }
                tooltipContent='A change you already expect during the loan, such as retiring, reduced hours or parental leave.'
            />
            <RevealSlot open={!!currentState}>
                <ForseeableChangesExplanation
                    baseId={baseId}
                    showErrors={showErrors && !!currentState}
                />
            </RevealSlot>
        </div>
    );
}
